import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Flex, Box, Text, Heading } from 'roo-ui/components';
import { useModal } from 'lib/hooks';
import { useDataLayer } from 'hooks/useDataLayer';
import Modal from 'components/Modal';
import TextButton from 'components/TextButton';
import CancellationRefundModal from 'components/CancellationRefundModal';
import OfferDepositPayMessage from './OfferDepositPayMessage';

const OfferDetails = memo(({ cancellationPolicy, offerDescription, counter, offerName, depositPay }) => {
  const { openModal, modalProps } = useModal();
  const { emitInteractionEvent } = useDataLayer();

  const handleOnClick = useCallback(() => {
    openModal();
    emitInteractionEvent({ type: 'Offer Details Pop Up', value: `Link Selected` });
  }, [emitInteractionEvent, openModal]);

  return (
    <Flex flexDirection="column">
      <Box>
        <Text color="greys.dusty" fontSize="xs" display={['none', 'block']}>
          OPTION {counter}
        </Text>
        <Heading.h3 display="block" mb="0" fontSize="base" lineHeight="normal">
          {offerName}
        </Heading.h3>
      </Box>
      <Flex flex="1 1 auto" mt={4} flexDirection="column" alignItems="flex-start">
        <CancellationRefundModal cancellationPolicy={cancellationPolicy} fontSize="base" mb={2} />
        <OfferDepositPayMessage depositPay={depositPay} />
        <TextButton onClick={handleOnClick} color="red" fontSize="base" aria-label={`Show details of ${offerName}`}>
          Show details
        </TextButton>

        <Modal {...modalProps} title="Offer description">
          <Box mb="5" data-testid="offer-description">
            <Heading.h4 fontSize="sm">{offerName}</Heading.h4>
            {offerDescription}
          </Box>
        </Modal>
      </Flex>
    </Flex>
  );
});

OfferDetails.propTypes = {
  cancellationPolicy: PropTypes.shape({
    isNonrefundable: PropTypes.bool.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
  offerDescription: PropTypes.string.isRequired,
  counter: PropTypes.number.isRequired,
  offerName: PropTypes.string.isRequired,
  depositPay: PropTypes.object.isRequired,
};

OfferDetails.displayName = 'OfferDetails';

export default OfferDetails;
